/* eslint no-fallthrough: 0 */

/* eslint default-case: 0 */
import { exists } from 'js/lib/utility/exists';
import { options } from 'js/features/apply_chosen';

function hasSelectedTrxTypeWithBankCodes() {
  var TRANSACTION_TYPES_WITH_BANK_CODES = ['online_banking'];

  for (var _i = 0, _TRANSACTION_TYPES_WI = TRANSACTION_TYPES_WITH_BANK_CODES; _i < _TRANSACTION_TYPES_WI.length; _i++) {
    var transaction_type = _TRANSACTION_TYPES_WI[_i];

    if ($('#pay_by_link_transaction_type_' + transaction_type).prop('checked')) {
      return true;
    }
  }

  return false;
}

function updateBankCodeSelect() {
  var bankCodeSelect = $('#pay_by_link_wpf_top_level_bank_code');
  var selectedBankCode = $('#pay_by_link_wpf_top_level_bank_code :selected').val();
  var emptyValue = '<option value="">' + I18n.t('javascript.options.please_select') + '</option>';
  var allBankCodes = ['PF', 'SN', 'IT', 'BR', 'BB', 'WP', 'BN', 'PS', 'BO', 'CPI', 'BCT', 'CA', 'AI', 'SE', 'BQ', 'EF', 'BC', 'IB', 'BP', 'PE', 'SP'];
  bankCodeSelect.empty();
  bankCodeSelect.append(emptyValue);

  for (var _i2 = 0, _allBankCodes = allBankCodes; _i2 < _allBankCodes.length; _i2++) {
    var bankCode = _allBankCodes[_i2];
    var option = $('<option/>').attr('value', bankCode).text(bankCode);

    if (bankCode === selectedBankCode) {
      option.attr('selected', 'selected');
    }

    bankCodeSelect.append(option);
  }

  bankCodeSelect.addClass('for_chosen').chosen(options);
  bankCodeSelect.trigger('chosen:updated');
}

function updateBankCodesFields() {
  var isTransactionWithBankCodeInRequest = hasSelectedTrxTypeWithBankCodes();

  if (isTransactionWithBankCodeInRequest) {
    updateBankCodeSelect();
    $('#wpf_top_level_bank_codes').removeClass('hidden');
  } else {
    $('#wpf_top_level_bank_codes').addClass('hidden');
  }
}

function listenForTransactionTypeChange() {
  var transactionTypesContainer = '.transaction-types-container';

  if (exists($(transactionTypesContainer))) {
    updateBankCodesFields();
    $(transactionTypesContainer).on('change', function () {
      updateBankCodesFields();
    });
  }
}

var PayByLinkBankCodes = {
  updateFields: updateBankCodesFields,
  listenForChange: listenForTransactionTypeChange
};
export default PayByLinkBankCodes;